
module.exports = {"attributes":{"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<rect width=\"15\" height=\"15\" rx=\"2\" fill=\"#3D343D\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
